export const MY_PROFILE_SECTIONS_MAPPER = {
  SKILLS: 'skills',
  RESUME: 'resumes',
  LANGUAGE: 'langauge',
  DATA_AND_PRIVACY_SETTINGS: 'data_privacy_settings',
};
export const MY_PROFILE_WIZARD_COMPONENT_MAPPER = {

  'ADDRESS': 'user-address',
  'CERTIFICATION': 'certification-questioner',
  'EDUCATION_HISTORY': 'education-history',
  'LANGUAGE': 'language',
  'LOCALE_LANGUAGE':'locale-language',
  'MY_DOCUMENTS': 'my-documents',
  'PROFESSIONAL_REFERENCE': 'professional-reference',
  'PROFILE_PICTURE': 'profile-picture',
  'PROTECTED_INFORMATION': 'protected_information',
  'RESUME': 'resume',
  'SKILLS': 'skills',
  'SKILLS_AND_SPECIALITY': 'skills',
  'SOURCE_TYPE': 'source-type',
  'WORK_PREFERENCE': 'user-preference',
  'JOB_PREFERENCE': 'user-preference',
  'WERE_YOU_REFERRED': 'were-you-referred',
  'WORK_EXPERIENCE': 'work-experience',
  'SAVE_AND_EXIT':'save-and-exit',
};

export const NEW_PROFILE_SECTION_KEY_MAPPER = {
  'user-address': 'ADDRESS',
  'personal_info': 'PERSONAL_INFO',
  'protected_information': 'PROTECTED_INFORMATION',
  'social_profiles': 'SOCIAL_PROFILES',
  'work-experience': 'WORK_EXPERIENCE',
  'skills': 'SKILLS_AND_SPECIALITY',
  'licence': 'LICENCE',
  'my-documents': 'MY_DOCUMENTS',
  'resumes': 'RESUME',
  'education-history': 'EDUCATION_HISTORY',
  'language': 'LANGUAGE',
  'locale-language': 'LOCALE_LANGUAGE',
  'user-preference': 'WORK_PREFERENCE',
  'job-preference': 'WORK_PREFERENCE',
  'professional-reference': 'PROFESSIONAL_REFERENCE',
  'notification': 'NOTIFICATION_PREFERENCE',
  'change_password': 'CHANGE_PASSWORD',
  'profile-picture': 'PROFILE_PICTURE',
  'source-type': 'SOURCE_TYPE',
  'were-you-referred': 'WERE_YOU_REFERRED',
  'data_privacy_settings': 'DATA_AND_PRIVACY_SETTINGS',
  'additional_documents': 'ADDITIONAL_DOCUMENTS',
  'passport': 'PASSPORT',
  'discipline_specialties': 'DISCIPLINE_SPECIALTIES',
};


export function stepNameTextMapping(step) {
  const stepKey = MY_PROFILE_WIZARD_COMPONENT_MAPPER[step] || step;
  const textMapping = {
    'user-address': 'Address',
    'certification-questioner': 'Certification Questionnaire',
    'education-history': 'Education History',
    language: 'Language',
    'my-documents': 'My Documents',
    'professional-reference': 'Professional References',
    'profile-picture': 'Profile Picture',
    protected_information: 'Protected Information',
    resume: 'Resume',
    skills: 'Skills/Specialties',
    'source-type': 'Source',
    'user-preference': 'Job Preference',
    'were-you-referred': 'Were you referred?',
    'work-experience': 'Work Experience',
  };
  if (textMapping[stepKey]) return textMapping[stepKey] || step;
};

